var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgRoundShape1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 602,
    height: 602,
    viewBox: "0 0 602 602",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301 599C448.46 599 568 479.46 568 332C568 184.54 448.46 65 301 65C153.54 65 34 184.54 34 332C34 479.46 153.54 599 301 599Z",
    fill: "#00BAB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M301 588C452.878 588 576 464.878 576 313C576 161.122 452.878 38 301 38C149.122 38 26 161.122 26 313C26 464.878 149.122 588 301 588Z",
    fill: "#245D51"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M301 602C467.238 602 602 467.238 602 301C602 134.762 467.238 0 301 0C134.762 0 0 134.762 0 301C0 467.238 134.762 602 301 602Z",
    fill: "#00BAB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 602,
    height: 602,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgRoundShape1);
export default __webpack_public_path__ + "static/media/bg-round-shape-1.43d08cf72c6153036aafa41529932ed7.svg";
export { ForwardRef as ReactComponent };